// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__IMIJS","modalForm":"UpgradeEpcsModal_modalForm__2Qcur","modalFooter":"UpgradeEpcsModal_modalFooter__1lH_1"};